import type { ApolloError, ApolloClient, NormalizedCacheObject } from '@apollo/client';

import { createApolloClient, parseError as origParseError } from '@jerry-serverless/graphql-helpers/apollo/client';
import { ClientNameEnum } from '@jerry-serverless/async-local-storage/enums';

/**
 * Parses Apollo error and returns readable message.
 * Checks API returned error in data first. Next, delegates to `origParseError`.
 *
 * @param data
 * @param error
 */
export const parseError = (error: ApolloError, data?: { errors?: { message: string }[] } | null): string => {
  const dataError = (data?.errors || [])[0];
  if (dataError) {
    return dataError.message;
  }

  return origParseError(error);
};

// Default Apollo client.
export const client = createApolloClient({
  uri: typeof window === 'undefined' ? process.env.NEXT_PUBLIC_API_URL : '/api/signup-service/graphql',
  clientName: ClientNameEnum.Signup,
});

/**
 * Get apollo client
 */
export function getClient(): ApolloClient<NormalizedCacheObject> {
  return client;
}

const refiClient = createApolloClient({
  uri: typeof window === 'undefined' ? process.env.NEXT_PUBLIC_REFI_API_URL : '/api/refi/graphql',
  clientName: ClientNameEnum.Signup,
});

/**
 * Get refi apollo client
 */
export function getRefiClient(): ApolloClient<NormalizedCacheObject> {
  return refiClient;
}

const quotingClient = createApolloClient({
  uri: typeof window === 'undefined' ? process.env.NEXT_PUBLIC_QUOTING_API_URL : '/api/quoting-service/graphql',
  clientName: ClientNameEnum.Signup,
});

const garageClient = createApolloClient({
  uri: typeof window === 'undefined' ? process.env.NEXT_PUBLIC_GARAGE_API_URL : '/api/garage/graphql',
  clientName: ClientNameEnum.Signup,
});

/**
 * Get quoting apollo client
 */
export function getQuotingClient(): ApolloClient<NormalizedCacheObject> {
  return quotingClient;
}

/**
 * Get garage client
 */
export function getGarageClient(): ApolloClient<NormalizedCacheObject> {
  return garageClient;
}

export const jerry2Uri = typeof window === 'undefined' ? `${process.env.NEXT_PUBLIC_HOST}/graphql` : '/graphql';

const jerry2Client = createApolloClient({
  uri: jerry2Uri,
  clientName: ClientNameEnum.Signup,
});

/**
 * get jerry2 apollo client
 */
export function getJerry2Client(): ApolloClient<NormalizedCacheObject> {
  return jerry2Client;
}
